import { render, staticRenderFns } from "./ArticleListBlock.vue?vue&type=template&id=6d9ed3da&"
import script from "./ArticleListBlock.vue?vue&type=script&lang=js&"
export * from "./ArticleListBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9ed3da')) {
      api.createRecord('6d9ed3da', component.options)
    } else {
      api.reload('6d9ed3da', component.options)
    }
    module.hot.accept("./ArticleListBlock.vue?vue&type=template&id=6d9ed3da&", function () {
      api.rerender('6d9ed3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/ArticleListBlock/ArticleListBlock.vue"
export default component.exports